/**
 * Search widget component.
 * @module components/theme/SearchWidget/SearchWidget
 */

import { useState } from 'react';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
// import styles from './SearchWidget.module.less';
import { defineMessages } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import SearchAutocomplete from './components/SearchAutocomplete/SearchAutocomplete';
import VoiceSearch from './components/VoiceSearch/VoiceSearch';

const messages = defineMessages({
  openSearchLabel: {
    id: 'open search',
    defaultMessage: 'open search',
  },
  closeSearchLabel: {
    id: 'close search',
    defaultMessage: 'close search',
  },
});

const SearchWidget = ({ pathname, history, intl }) => {
  const [active, setActive] = useState(false);

  const onToggle = () => {
    setActive(!active);
  };

  return (
    <div className="header-actions">
      <SearchAutocomplete
        active={active}
        history={history}
        pathname={pathname}
      />
      <div className="header-search-trigger">
        {active ? (
          <button
            className="br-button circle ml-1"
            type="button"
            aria-label={intl.formatMessage(messages.closeSearchLabel)}
            title={intl.formatMessage(messages.closeSearchLabel)}
            onClick={onToggle}
          >
            <i className="fas fa-times" aria-hidden="true"></i>
          </button>
        ) : (
          <>
            <VoiceSearch />
            <button
              className="br-button circle"
              type="button"
              aria-label={intl.formatMessage(messages.openSearchLabel)}
              title={intl.formatMessage(messages.openSearchLabel)}
              onClick={onToggle}
            >
              <i className="fas fa-search" aria-hidden="true"></i>
            </button>
          </>
        )}
      </div>
    </div>
  );
};

SearchWidget.propTypes = {
  pathname: PropTypes.string,
  active: PropTypes.bool,
  onClose: PropTypes.func,
};

export default compose(withRouter, injectIntl)(SearchWidget);
